import React from "react";
import ReactDOM from "react-dom/client";
// CSS Tailwind đã biên dịch sẵn (tạo bởi script "tw"/"tw:watch"). KHÔNG import
// tailwind.css nguồn — CRA không compile được nó.
import "./assets/styles/tailwind.output.css";
import "./assets/styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/store";
import "@radix-ui/themes/styles.css";
import { Theme } from '@radix-ui/themes';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Theme>
      <App />
    </Theme>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
